import { i18n } from 'locales';

import { createApp } from 'vue';
import WebGlViewer from 'components/shared/WebGlViewer.vue';
import WebGlStatus from 'components/shared/WebGlStatus.vue';
import AssemblyBar from 'components/boards/AssemblyBar.vue';
import AssemblyUnavailableOverlay from 'components/boards/AssemblyUnavailableOverlay.vue';
import CanvasMiniMap from 'components/shared/CanvasMiniMap.vue';
import AssemblyInspectorControls from 'components/boards/AssemblyInspectorControls.vue';
import ProjectCheckoutButton from 'components/project/ProjectCheckoutButton.vue';

// Add mitt as backport for eventbus
import mitt from 'mitt';

const app = createApp({
  data() {
    return {
      bus: mitt(),
      messageColor: 'black',
      message: '',
    };
  },
});
app.use(i18n);

app.component(WebGlViewer.name, WebGlViewer);
app.component(WebGlStatus.name, WebGlStatus);
app.component(AssemblyBar.name, AssemblyBar);
app.component(AssemblyUnavailableOverlay.name, AssemblyUnavailableOverlay);
app.component(CanvasMiniMap.name, CanvasMiniMap);
app.component(AssemblyInspectorControls.name, AssemblyInspectorControls);

app.mount('#vue-board-inspector');

const app2 = createApp();
app2.component(ProjectCheckoutButton.name, ProjectCheckoutButton);
app2.use(i18n);
app2.mount('#vue-project-checkout-button');
